import(/* webpackMode: "eager", webpackExports: ["VenueFAQsClient"] */ "/app/components/admin/faqs/venue-faqs-client.tsx");
